import React, { useState, useEffect } from "react";

import { toast } from "react-toastify";
import { privateAxiosIntance, publicAxiosInstance } from "../../Config/axios";
import axios from "axios";

const FacebooxPixelForm = () => {
  const [apiKey, setApiKey] = useState("");

  const [loading, setLoading] = useState(false);
  const [response, setResponse] = useState(null);
  const [error, setError] = useState("");
  const [isUpdate, setIsUpdate] = useState(false);

  useEffect(() => {
    fetchAdsenseData();
  }, []);

  const fetchAdsenseData = async () => {
    try {
      const result = await privateAxiosIntance.get("blog/facebook-pixel-api/");
      if (result?.data && result?.data?.data?.pixel_key) {
        setApiKey(result?.data?.data?.pixel_key);

        toast.success(result?.data?.data?.msg);
        setIsUpdate(true);
      } else {
        toast.success(result?.data?.data?.msg);
        setIsUpdate(false);
      }
    } catch (err) {
      setError("Failed to fetch AdSense data.");
    }
  };

  const handleApiKeyChange = (e) => {
    setApiKey(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    setResponse(null);

    try {
      const apiUrl = isUpdate
        ? `blog/facebook-pixel-api/`
        : "blog/facebook-pixel-api/";

      const method = isUpdate ? "post" : "post";

      const result = await privateAxiosIntance[method](
        apiUrl,
        {
          pixel_key: apiKey,
        },

        // {
        //     headers: {
        //         authorization: "Token " + localStorage.getItem("token"),
        //         "Access-Control-Allow-Origin": "*",
        //     },
        // }
      );

      //   console.log(result?.data?.msg);
      toast.success(result?.data?.message);

      setResponse(result.data);
      fetchAdsenseData();
    } catch (err) {
      setError("An error occurred while submitting the AdSense data.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[90vh] w-full flex items-center justify-center bg-gray-200">
      <div className="max-w-2xl mx-auto p-6 bg-white rounded-lg shadow-lg w-full">
        <h1 className="text-2xl font-bold text-center mb-6">
          {isUpdate ? "Update" : "Add"} Your API Key to Facebook Pixel
        </h1>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="flex flex-col">
            <label htmlFor="apiKey" className="text-lg font-medium mb-2">
              API Key
            </label>
            <input
              type="text"
              id="apiKey"
              name="apiKey"
              value={apiKey}
              onChange={handleApiKeyChange}
              placeholder="Enter your API Key"
              className="p-3 border border-gray-300 rounded-md text-lg"
              required
            />
          </div>
          <button
            type="submit"
            className={`w-full py-3 text-white font-semibold rounded-md transition-all duration-300 ${
              loading
                ? "bg-gray-400 cursor-not-allowed"
                : "bg-blue-500 hover:bg-blue-600"
            }`}
            disabled={loading}
          >
            {loading ? "Loading..." : isUpdate ? "Update" : "Submit"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default FacebooxPixelForm;
